// ANNOUNCEMENT BAR
register('announcement-bar', {
  onLoad() {
    var slider = tns({
      container: '.js-slick-announcement',
      controls: false,
      autoplay: true,
      mode: 'gallery',
      autoHeight: true,
      items: 1,
      swipeAngle: false,
      autoplayButton: false,
      autoplayButtonOutput: false,
      nav: false,
      speed: 400,
      preventScrollOnTouch: 'auto'
    });

    const announcement = document.getElementById("section-announcement");
    const announcementInner = announcement.querySelector('.tns-liveregion');
    announcementInner.remove();
  },
  onUnload() {
    this.container.off(this.namespace);
  },
});
load('announcement-bar');

// HEADER
const selectorsHeader = {
  mobileNavToggle: '.js-mobile-nav-toggle',
  mainNavBar: '#main-navbar',
  navLink: '.main-navbar__item.has-child',
  mobileNavDrawer: '.mobile-navigation-wrapper',
  mobileNavBar: '.mobile-nav',
  navLinkMobile: '.mobile-nav__item.has-child',
  navBackMobile: '.mobile-nav__return-btn'
};

const classesHeader = {
  sticky: 'is-sticky',
  open: 'is-open',
  active: 'is-active',
  mobileOpen: 'mobile-open',
  filterOpen: 'filter-open'
};

register('header', {
  onLoad() {
    window.addEventListener('scroll', debounce(this.stickyHeader, 16),false);
    window.addEventListener('resize', debounce(this.stickyHeader, 16),false);
  	this.toggleHeaderSearch();
    this.initMegaMenu();
    this.initMobileMenu();
    
    const roSelf = this;
    const ro = new ResizeObserver( debounce(function(entries){
      for (let entry of entries) {
        if( viewportWidth() <= 768  ) {
          roSelf.setScreenSize();
        }
      }
    }, 200));
    ro.observe(this.container);
    
    // Initiate search forms
    const searchForms = document.querySelectorAll('[search-input]');
    searchForms.forEach(form => {
      this.initSuggestionsDrawer(form);  
    })
  },
  stickyHeader: function(){
    const announcementBar = document.querySelector('.announcementBar');
    const promotionBar = document.querySelector('.promotionBar');
    const site_header = document.querySelector('.site-header');
    const mobileNavDrawer = document.querySelector(selectorsHeader.mobileNavDrawer);
    const pdpGallerySticky = document.querySelector('.pdp-product .is-sticky');
    if( !site_header ){
      return false;
    }
    let lastScrollTop = announcementBar ? announcementBar.offsetHeight : 0;
    lastScrollTop += (promotionBar ? promotionBar.offsetHeight : 0);
    lastScrollTop += (site_header ? site_header.offsetHeight : 0);
    let offsetHeight = lastScrollTop;
    let currScrollTop = window.scrollY;
    let isScrollingDown = currScrollTop >= lastScrollTop;
    let isHeaderVisible = currScrollTop < offsetHeight;
    site_header.classList.toggle(classesHeader.sticky, isScrollingDown && !isHeaderVisible);
    if( isScrollingDown && !isHeaderVisible ){
      site_header.parentNode.style.paddingTop = site_header.offsetHeight + 'px';
      site_header.classList.add(classesHeader.sticky);
      if (pdpGallerySticky) {
        pdpGallerySticky.style.top =  site_header.offsetHeight + 'px';
      }
    }else{
      site_header.classList.remove(classesHeader.sticky);
      site_header.parentNode.style.paddingTop = '0px';
      if (pdpGallerySticky) {
        pdpGallerySticky.style.top = '0px';
      }
    }
    lastScrollTop = currScrollTop;
    let filter_container = document.querySelector('.plp-filters-container');
    if (site_header.classList.contains('is-sticky')) {
      mobileNavDrawer.style.paddingTop = site_header.offsetHeight + 'px';
      if (filter_container) {
        filter_container.style.paddingTop = site_header.offsetHeight + 'px';
      }
    }else{
      mobileNavDrawer.style.paddingTop = ((offsetHeight - currScrollTop) > 0 ? offsetHeight - currScrollTop : 0) + 'px';
      if (filter_container) {
        filter_container.style.paddingTop = ((offsetHeight - currScrollTop) > 0 ? offsetHeight - currScrollTop : 0) + 'px';
      }
    }
  },
  toggleHeaderSearch: function(){
    const togglebtn = document.querySelectorAll('[data-action="toggle-search"]');
    const headerSearch = document.querySelector('#header-search');
    togglebtn.forEach( btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        if( !headerSearch.classList.contains(classesHeader.open) ){
          headerSearch.classList.add(classesHeader.open);
        }else{
          headerSearch.classList.remove(classesHeader.open);
        }
      })
    })
  },
  setScreenSize() {
    //const window_height = window.screen.height;
    const window_height = window.innerHeight;
    //const search_header_height = document.querySelector('.site-header-search').getBoundingClientRect().height;
    //const site_header_height = document.querySelector('.site-header-wrapper').getBoundingClientRect().height;
    // const suggested_links = document.querySelector('.suggested__links').getBoundingClientRect().height;
    //const offset_height = search_header_height + site_header_height;
    /*const container_top = document.querySelector('.suggest__drawer--wrapper').getBoundingClientRect().top;
    const container_height = window_height - container_top;
    // document.querySelector('.suggested__products').style.maxHeight = `${container_height}px`;
    document.querySelector('.suggest__drawer--wrapper').style.maxHeight = `${container_height}px`;
    */
    if( !document.querySelector('#MainContent') ){
      return;
    }
    const container_top = document.querySelector('#MainContent').getBoundingClientRect().top;
    const container_height = window_height - container_top;

    var head = document.getElementsByTagName('head')[0];

    var style = document.querySelector('#suggest__drawer_inlinecss');
    if( !style ){
      style = document.createElement('style');
      style.id = 'suggest__drawer_inlinecss';
      style.type = 'text/css';
      head.append(style);
    }
    style.innerText = '.suggest__drawer--wrapper{max-height: '+ `${container_height}px` +'}'
    
  },
  initSuggestionsDrawer(el) {
    let drawerState = 'inactive';
    const targetDrawer = el.getAttribute('data-drawer');
    const closeButton = document.querySelectorAll("[search-button]");
    const inputs = document.querySelectorAll('[search-input]');
    const searchSelectors = document.querySelectorAll("[search-icon]");

    const setState = (state) => {
      drawerState = state;
      this.toggleSearchIcons(searchSelectors);
    }

    const clearInputs = () => {
      inputs.forEach(input => {
        input.value = "";
      });
    }
    
    el.addEventListener('input', (evt) => {
      if(evt.target.value != "" && drawerState == 'inactive') {
        this.openSuggestionsDrawer(targetDrawer);
        setState('active');
      } else if(evt.target.value == "" && drawerState == 'active') {
        this.closeSuggestionsDrawer(targetDrawer);
        setState('inactive');
        clearInputs();
      }
    });
    
    closeButton.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        let currState = e.target.closest('.search__icon-js').classList.contains('.search--close-js');
        if( currState == true ) {
          console.log('is close: ');
        } else {
          console.log('no bueno: ');
        }
        // e.preventDefault();
          document.querySelector('.search--close-js').classList.remove('active');
          document.querySelector('.search--search-js').classList.add('active');
          document.querySelector('.mobile--search--close-js').classList.remove('active');
          document.querySelector('.mobile--search--search-js').classList.add('active');
        
        clearInputs();
        let iconsAll = document.querySelectorAll('[search-icon]');
        let iconsArr = [].slice.call(iconsAll);
        this.toggleSearchIcons(iconsArr);
        this.closeSuggestionsDrawer(targetDrawer);
        setState('inactive');
      });
    })
    
  }, 
  openSuggestionsDrawer(el) {
    const drawer = document.querySelector(el);
    if (!drawer) { return; }
    drawer.classList.add('drawer--open');
    document.querySelector('body').classList.add('suggest--open');
    const backToTop = document.querySelector('svg.back-to-top');
    
    if ( viewportWidth <= 768 ) {
      backToTop.style.display = "none";  
    }
  },
  closeSuggestionsDrawer(el) {
    const drawer = document.querySelector(el);
    if (!drawer) { return; }
    drawer.classList.remove('drawer--open');
    document.querySelector('body').classList.remove('suggest--open');
    const backToTop = document.querySelector('svg.back-to-top');

    if ( viewportWidth <= 768 ) {
      backToTop.style.display = "block";
    }
  },
  toggleSearchIcons(selectorsHeader) {
    selectorsHeader.forEach( (selector) => {
      console.log('my selector: ' + selector.classList)
      selector.classList.toggle('active');
    })
  },
  initMegaMenu(){
    let nav_item = document.querySelectorAll(selectorsHeader.navLink);
    nav_item.forEach(item => {
      item.addEventListener('mouseenter', (evt) => {
        this.openMegaMenu(evt)
      });
      item.addEventListener('mouseleave', (evt) => {
        this.closeMegaMenu(evt)
      });
      
      item.querySelector('.main-navbar__link').addEventListener('focus', (evt) => {
        document.querySelectorAll('.mega-menu-block.is-open').forEach(el => {
          el.classList.remove('is-open');
        })
        if ( evt.target.classList.contains('main-navbar__link') ) {
          document.querySelector('body').classList.add('menu-open');
          evt.target.nextElementSibling.classList.add(classesHeader.open);
        }
      });
      item.querySelectorAll('.mega-menu-block a').forEach(el => {
        el.addEventListener('focus', (evt) => {
          document.querySelectorAll('.mega-menu-block.is-open').forEach(el => {
            el.classList.remove('is-open');
          })
          document.querySelector('body').classList.add('menu-open');
          el.closest('.mega-menu-block').classList.add(classesHeader.open);
        });
      })
    })
  },
  openMegaMenu(evt) {
    if ( viewportWidth <= 1024) {
      return;
    }
    document.querySelector('body').classList.add('menu-open');
    evt.currentTarget.querySelector('.mega-menu-block').classList.add(classesHeader.open);
  },
  closeMegaMenu(evt) {
    if ( viewportWidth <= 1024) {
      return;
    }
    const $this = evt.currentTarget;
    document.querySelector('body').classList.remove('menu-open');
    $this.querySelector('.mega-menu-block').classList.remove(classesHeader.open);
  },
  initMobileMenu(){
    const backBtn = document.querySelectorAll(selectorsHeader.navBackMobile);
    const nav_item = document.querySelectorAll(selectorsHeader.navLinkMobile);
    const mobileNavToggle_btn = document.querySelectorAll(selectorsHeader.mobileNavToggle);
    const mobileNavDrawer = document.querySelector(selectorsHeader.mobileNavDrawer);
    const body = document.querySelector('body');
    const mobileNavBar = document.querySelector(selectorsHeader.mobileNavBar);
    nav_item.forEach(item => {
      item.querySelector('a.mobile-nav__link') ? 
      item.querySelector('a.mobile-nav__link').addEventListener('click', (evt) => {
        /*
        if ( evt.target.classList.contains('mobile-nav__icon') || evt.target.closest('.mobile-nav__icon') ) {
          evt.preventDefault();
        }*/
        if (item.querySelector('.mobile-nav__icon')) {
          evt.preventDefault();
        }
        evt.stopPropagation();
        
        mobileNavBar.scroll(0,0);
        if (item.classList.contains('level-1')) {
          document.querySelector(selectorsHeader.mobileNavBar).classList.add('sub-nav--is-open');
        }else{
          item.closest('.mobile-nav__dropdown').classList.add('sub-nav--is-open');
        }
        item.classList.add('is-active');
      }) : !1;

      if ( item.querySelector('.nav-level-3') && item.parentNode.classList.contains('level-2') ) {
        var item_length = [...item.querySelectorAll('.mobile-nav__item')].length;
        if( item_length < 2 ){
          item.classList.remove('has-child');
          let icon = item.querySelector('.mobile-nav__icon');
          if ( icon ) {
            icon.parentNode.removeChild(icon);
          }
        }
      }
    });

    backBtn.forEach(btn => {
      btn.addEventListener('click', (evt) =>{
        evt.preventDefault();
        evt.stopPropagation();
        btn.closest('.sub-nav--is-open').classList.remove('sub-nav--is-open');
        btn.closest('li.is-active').classList.remove('is-active');
      })
    })

    mobileNavToggle_btn.forEach(btn => {
      btn.addEventListener('click', (evt) =>{
        evt.preventDefault();
        let filter_container = document.querySelector('.plp-filters-container');
        if ( filter_container && body.classList.contains(classesHeader.filterOpen) ) {
          filter_container.classList.remove(classesHeader.active);
          body.classList.remove(classesHeader.filterOpen);
          evt.currentTarget.classList.remove(classesHeader.active);
          return;
        }
        if ( !mobileNavDrawer ) {
          return;
        }
        const announcementBar = document.querySelector('.announcementBar');
        const promotionBar = document.querySelector('.promotionBar');
        const site_header = document.querySelector('.site-header');
        let headerHeight = announcementBar ? announcementBar.offsetHeight : 0;
        headerHeight += (promotionBar ? promotionBar.offsetHeight : 0) + (site_header ? site_header.offsetHeight : 0);
        if (site_header.classList.contains('is-sticky')) {
          headerHeight = (site_header ? site_header.offsetHeight : 0)
        }else{
          let currScrollTop = window.scrollY;
          headerHeight -= currScrollTop;
        }
        mobileNavDrawer.style.paddingTop = headerHeight + 'px';
        mobileNavDrawer.classList.toggle(classesHeader.active);
        evt.currentTarget.classList.toggle(classesHeader.active);
        body.classList.toggle(classesHeader.mobileOpen);
      })
    })
  },
  onUnload() {
    this.container.off(this.namespace);
  },
});
load('header');

// FOOTER
const selectorsFooter = {
  backToTopButton: document.querySelector('.back-to-top'),
  footer: document.querySelectorAll('.footer')
}
register('footer', {
  onLoad() {
      this.initAccordion();
      const observerConfig = {threshold: 0.35};
      const observer = new IntersectionObserver(this.handleIntersection, observerConfig);
      const observedElements = document.querySelectorAll('.footer');
      observedElements.forEach(el => observer.observe(el));
      
      selectorsFooter.backToTopButton.addEventListener('click', this.backToTop);
      document.addEventListener('scroll', this.handleScroll);
  },
  initAccordion() {
      const accordions = document.querySelectorAll(".column-footer-menu");
  
      accordions.forEach((el) => {
          const intro = el.querySelector(".footer-menu-title");
          const content = el.querySelector(".footer-menu-toggle");
  
          intro.onclick = () => {
              content.style.maxHeight ? this.closeAccordion(el) : this.openAccordion(el);
          };
      });
  },
  openAccordion(el) {
      const content = el.querySelector(".footer-menu-toggle");
      el.classList.add("active");
      content.style.maxHeight = content.scrollHeight + "px";
  },
  closeAccordion(el) {
      const content = el.querySelector(".footer-menu-toggle");
      el.classList.remove("active");
      content.style.maxHeight = null;
  },
  handleScroll() {
      let scrolled = window.pageYOffset;
      const clientH = document.documentElement.clientHeight;
      const pageHeight = document.body.scrollHeight;
      const windowHeight = window.innerHeight;
      const footerHeight = selectorsFooter.footer.clientHeight;
  
      if (scrolled > clientH) {
        selectorsFooter.backToTopButton.classList.add('show');
      }
      if (scrolled < clientH) {
        selectorsFooter.backToTopButton.classList.remove('show');
      }
  },
  backToTop() {
      if (window.pageYOffset > 0) {
          window.scroll({top: 0, left: 0, behavior: 'smooth'});
      }
  },
  handleIntersection(entries) {
      entries.map((entry) => {
          if (entry.isIntersecting) {
          entry.target.classList.add('makeRelative')
          document.querySelector(".back-to-top").classList.add("makeAbsolute");
          } else {
              entry.target.classList.remove('makeRelative')
              document.querySelector(".back-to-top").classList.remove("makeAbsolute");
          }
      });
  },
  onUnload() {
      observer.unobserve(footer);
  },
}); 
load('footer');

// Common a11y fixes
focusHash();
bindInPageLinks();
selectDropdown();
wrapTable();
initAccordion();
toggleSidebarMenu();
qtySelectors();
smoothSroll();
breadcrumbs();

// Apply a specific class to the html element for browser support of cookies.
if (window.navigator.cookieEnabled) {
  document.documentElement.className = document.documentElement.className.replace(
    'supports-no-cookies',
    'supports-cookies',
  );
}

function breadcrumbs(){
	const $container = document.querySelector('nav.breadcrumbs');
	if( !$container || !ResizeObserver ) return;
	const ro = new ResizeObserver( debounce(function(entries){
      for (let entry of entries) {
        $container.scrollTo({left: $container.scrollWidth});
        if( $container.scrollWidth > $container.offsetWidth ){
          $container.closest('.breadcrumbs-wrapper').classList.add('breadcrumbs--long');
        }else{
          $container.closest('.breadcrumbs-wrapper').classList.remove('breadcrumbs--long');
        }
        return;
      }
    }, 200));
    ro.observe($container);

}
function smoothSroll() {
  document.querySelectorAll('a[href*="#"]').forEach(a => {
  	a.addEventListener('click', (e) => {
      if( e.target.getAttribute('href') == '#' || e.target.getAttribute('href') == undefined ){
        return;
      }
  		let href = e.target.getAttribute('href'),
  				hash = href.split('#')[1];
			if (
        window.location.pathname.replace(/^\//, '') == a.pathname.replace(/^\//, '')
        && window.location.hostname == a.hostname
        && href != '#' && href != '#0'
	    ){
        e.preventDefault();
        var target = document.querySelector('#' + hash);

        target = target ? target : document.querySelector('[name=' + hash + ']');
        if ( target ) {
			    var stickyHeight = parseInt(document.querySelector('#shopify-section-header header').offsetHeight);
			    var stickwrapper = parseInt(document.querySelector('#shopify-section-header').offsetHeight);
			    var top = target.offsetTop;
			    if (top >= stickwrapper) {
			        top -= stickwrapper;
			    }
			    $('html, body').animate({
			        scrollTop: top
			    }, 500);
				}
	    }
  	})
  })
}

if (deviceType() == 'tablet' || deviceType() == 'mobile') {
  document.documentElement.classList.add('dt-' + deviceType());
}else{
  document.documentElement.classList.add('dt-desktop');
}

//Disable Auto Zoom in Input "Text" tag - Safari on iPhone
if ( navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform) ){
  preventZoomOnFocus();
}
function preventZoomOnFocus(){
  document.documentElement.addEventListener("touchstart", onTouchStart);
  document.documentElement.addEventListener("focusin", onFocusIn);
}
function onTouchStart(evt){
  let dont_disable_for = ["checkbox", "radio", "file", "button", "image", "submit", "reset", "hidden"];
  let tn = evt.target.tagName;
  // No need to do anything if the initial target isn't a known element
  // which will cause a zoom upon receiving focus
  if (    tn != "SELECT"
      &&  tn != "TEXTAREA"
      && (tn != "INPUT" || dont_disable_for.indexOf(evt.target.getAttribute("type")) > -1)
     )
    return;
  // disable zoom
  setViewport("width=device-width, initial-scale=1.0, user-scalable=0");
}
// NOTE: for now assuming this focusIn is caused by user interaction
function onFocusIn(evt){
  // reenable zoom
  setViewport("width=device-width, initial-scale=1.0, user-scalable=1");
} 
// add or update the <meta name="viewport"> element
function setViewport(newvalue){
  let vpnode = document.documentElement.querySelector('head meta[name="viewport"]');
  if (vpnode)
    vpnode.setAttribute("content",newvalue);
  else
  {
    vpnode = document.createElement("meta");
    vpnode.setAttribute("name", "viewport");
    vpnode.setAttribute("content", newvalue);
  }
}